import { PRODUCTS_ACCESS } from "@/helpers/permissionsConstant";

export default [
  {
    path: "/admin/sliders",
    name: "admin-sliders",
    component: () => import("@/views/admin/slider/SliderView.vue"),
    meta: {
      gate: PRODUCTS_ACCESS,
      requiresAuth: true,
      pageTitle: "Sliders",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Sliders",
          active: true,
          to: "",
        },
      ],
    },
  },
];
